import { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useController } from 'react-hook-form'

const PasswordField = ({
  errorProps = {},
  inputProps = {},
  labelProps = {},
  labelAction,
  name,
  toggleLabel,
}) => {
  const id = `id-${name}`
  const { label, required } = labelProps
  const { message, ignoreError } = errorProps
  const placeholder = inputProps.placeholder || 'enter value'
  const errorId = `${id}-error`

  const [visible, setVisible] = useState(false)

  const { field, fieldState: { invalid } } = useController({ name })
  const showError = !ignoreError && invalid && message

  const input = (
    <input
      id={id}
      type={visible ? 'text' : 'password'}
      autoComplete="current-password"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck="false"
      placeholder={placeholder}
      aria-invalid={!ignoreError && invalid ? true : undefined}
      aria-describedby={showError ? errorId : undefined}
      {...field}
      {...inputProps}
    />
  )

  return (
    <>
      {label && (labelAction ? (
        <div className="field-label-row">
          <label htmlFor={id}>
            <span className={clsx({ required })}>{label}</span>
          </label>
          {labelAction}
        </div>
      ) : (
        <label htmlFor={id}>
          <span className={clsx({ required })}>{label}</span>
        </label>
      ))}
      {toggleLabel ? (
        <div className="password-input">
          {input}
          <button
            type="button"
            data-testid="password-toggle"
            className={clsx('password-toggle', { 'is-visible': visible })}
            aria-label={toggleLabel}
            aria-pressed={visible}
            onClick={() => setVisible(!visible)}
          />
        </div>
      ) : input}
      {showError && <span id={errorId} className="form-error-msg" role="alert">{message}</span>}
    </>
  )
}

PasswordField.propTypes = {
  inputProps: PropTypes.shape({
    autoComplete: PropTypes.string,
    placeholder: PropTypes.string,
  }),
  errorProps: PropTypes.shape({
    message: PropTypes.string,
    ignoreError: PropTypes.bool,
  }),
  labelProps: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    required: PropTypes.bool,
  }),
  labelAction: PropTypes.node,
  name: PropTypes.string.isRequired,
  toggleLabel: PropTypes.string,
}

export default PasswordField
